import React from "react";
import CheckIcon from '@mui/icons-material/Check';
import DashIcon from '@mui/icons-material/HorizontalRule';
import Box from '@mui/material/Box';

interface IReportMatrixBoxProps {
    hasReport: boolean
}
export default function ReportMatrixBox({ hasReport }: IReportMatrixBoxProps) {

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height='100%'
        >
            {hasReport ?
                <CheckIcon color='secondary' />
                :
                <DashIcon />
            }
        </Box>
    );
};
